module.exports = __webpack_public_path__ + "static/media/contenedores6.a6bc7f25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos/seguridad/contenedores6.jpg
// module id = 200
// module chunks = 0